<template>
  <div class="consejo">
    <p class="open_modal" @click="openModalDatos">*</p>
    <Datos 
      v-if="modal_datos" 
      :tiempo="tiempo" 
      @cerrarModal="modal_datos = false"
    />
    <h3 :class="['frase', escena]">
      Anda, cógete <b>{{objetos[icon_ppal]}}</b><br>
      <span v-html="frases[tiempo.main][Math.floor(Math.random() * frases[tiempo.main].length)]"></span>
    </h3>
    <p>({{dato}})</p>
    <div class="iconos" :class="{'on': escena === 'e_iconos'}">
      <img :class="['mano_slide', icon_ppal]" :src="'img/brazo_abu.svg'" />
      <img class="icono_ppal" :src="'img/iconos/' + icon_ppal + '.svg'" />
      <span class="sombra_icono"></span>
      <div class="otros_consejos">
        <img v-for ="(icono, index) in other_icons" :key="index"
          :alt="icono" :src="'img/iconos/' + icono + '.svg'">
      </div>
    </div>
  </div>
</template>

<script>
import Datos from '@/components/Datos.vue'

export default {
  name: 'Consejo',
  components: {Datos},
  props: {
    tiempo: {}
  },
  data() {
    return {
      icon_ppal: null,
      other_icons: [],
      escena: 'e_frase',
      appear: false,
      objetos: {
        abrigo: 'el abrigo',
        botas_lluvia: 'unas botas para la lluvia',
        botella_agua: 'una botellita de agua',
        gafas_sol: 'las gafas de sol',
        gorro_nieve: 'un gorrito para la nieve',
        guantes_nieve: 'guantes para la nieve',
        lazo_viento: 'un lazo para el pelo',
        paraguas_nieve: 'un paraguas para la nieve',
        paraguas: 'el paraguas',
        rebeca: 'una rebeca',
        sandalias: 'las sandalias',
        sudadera: 'una sudadera'
      },
      frases: {
        Snow: ['que he visto unos renos por la ventana'],
        Drizzle: [', una bolsa de súper en la cabeza también vale'],
        Thunderstorm: ['que me han vibrado los huesos'],
        Rain: ['¡que lo noto en los juanetes!'],
        Atmosphere: ['que cuando en marzo mayea<br>en mayo marcea'],
        Clear: ['que hace un sol radiante'],
        Clouds: ['que las nubes no me mienten'],
        viento: ['que ojito con el viento'],
        sol: ['que pega que da gusto']
      },
      puede_llover: false,
      mucho_calor: false,
      mucho_viento: false,
      modal_datos: false,
      dato: null
    }
  },
  created: function() {
    if (this.tiempo) {
    //lluvia
      if (this.tiempo.lluvia > .15) {
        this.puede_llover = true;
        this.icon_ppal = 'paraguas';
        this.dato = 'Hay una probabilidad de que llueva del ' + this.tiempo.lluvia + '%'
      } else if (this.tiempo.temperatura > 30) {
        this.mucho_calor = true;
        this.icon_ppal = 'botella_agua';
      } else if (this.tiempo.viento > 1) {
        this.mucho_viento = true;
        this.icon_ppal = 'lazo_viento';
        this.dato = 'Hace un viento de ' + this.tiempo.viento + ' m/s'
      }
    //si no llueve, abrigo según temperatura
      else if (this.tiempo.temperatura < 10) this.icon_ppal = 'abrigo';
      else if (this.tiempo.temperatura < 17) this.icon_ppal = 'sudadera';
      else if (this.tiempo.temperatura < 22) this.icon_ppal = 'rebeca';
    //si hace calorcete, y está despejado
      else if (this.tiempo.nubes < 5) this.icon_ppal = 'gafas_sol';
      else if (this.tiempo.temperatura >= 23) this.icon_ppal = 'sandalias';
    }
  },
  mounted: function() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.escena = 'e_iconos';
      }, 1500);
    })
  },
  methods: {
    openModalDatos() {
      this.modal_datos = true;
    }
  }
}
</script>
<style scoped lang="scss">
.consejo {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-evenly;
  .frase {
    margin-bottom: 1em;
    b {font-weight: bold;}
  }
  .open_modal {
    position: absolute;
    top: 1em;
    right: 1em;
    font-weight: bold;
    font-size: 1.5rem;
  }
  // .frase {

  //   &:not(.e_frase) {
      
  //   }
  // }
  .iconos {
    position: relative;
    width: 60%;
    height: auto;
    margin-top: 10%;
    .icono_ppal {
      position: relative;
      width: 100%;
      display: block;
      z-index: 10;
      left: -75vw;
      // transition: left .5s ease-out;
    }
    .mano_slide {
      position: absolute;
      width: 100%;
      z-index: 11;
      left: -100vw;
      &.paraguas {top: 70%;}
    }
    &.on .icono_ppal {animation: icono_ppal 3s ease-out forwards;}
    &.on .mano_slide {animation: 1 brazo_abu 3s ease-out;}
   
    .sombra_icono {
      position: absolute;
      top: -15%;
      left: -15%;
      width: 130%;
      height: 130%;
      border-radius: 100%;
      background: rgba(255, 255, 255, 0.7);
      mix-blend-mode: overlay;
      filter: blur(20px);
      z-index: 0;
      opacity: 0;
      transition: opacity .5s ease-in-out .5s;
    }
    &.on .sombra_icono {opacity: 1;}
  }
}
</style>
